<template>
  <v-flex xs12>
    <v-card>
      <v-card-title>
        <v-flex xs12 class="mb-5">
          <h4>{{ pageTitle }}</h4>
        </v-flex>
        <v-flex xs12>
          <v-form ref="form" lazy-validation @submit.prevent="submit">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md4>
                  <v-menu
                    v-model="menu.departureDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="departureDate"
                        label="Departure Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        name="departureDate"
                        v-validate="'required|date_format:yyyy-MM-dd'"
                        data-vv-as="Departure Date"
                        :error-messages="errors.collect('departureDate')"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="todayDate"
                      v-model="departureDate"
                      @input="menu.departureDate = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="totalDays"
                    name="totalDays"
                    label="Total Days"
                    v-validate="'required|numeric'"
                    data-vv-as="Total Days"
                    :error-messages="errors.collect('totalDays')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="maxGroupSize"
                    name="maxGroupSize"
                    label="Max Group Size"
                    v-validate="'required|numeric'"
                    data-vv-as="Max Group Size"
                    :error-messages="errors.collect('maxGroupSize')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="fixedPax"
                    name="fixedPax"
                    label="Fixed Pax"
                    v-validate="'required|numeric'"
                    data-vv-as="Fixed Pax"
                    :error-messages="errors.collect('fixedPax')"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field
                    v-model="remarks"
                    name="remarks"
                    label="Remarks"
                    :counter="100"
                    v-validate="'required|max:100'"
                    data-vv-as="Remarks"
                    :error-messages="errors.collect('remarks')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>

            <v-divider class="mt-5"></v-divider>
            <v-card-actions>
              <v-btn color="success" type="submit">
                <v-icon>save</v-icon>Save
              </v-btn>
              <v-btn color="error" @click="reset">Reset</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import store from "../../store";
import commonservice from "../../shared/common.service";
export default {
  computed: {
    fixedPax: {
      get() {
        return this.$store.state.fixedDeparture.entity.fixedPax;
      },
      set(val) {
        this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
          key: "fixedPax",
          value: val
        });
      }
    },
    departureDate: {
      get() {
        return this.$store.state.fixedDeparture.entity.departureDate;
      },
      set(val) {
        this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
          key: "departureDate",
          value: val
        });
      }
    },
    totalDays: {
      get() {
        return this.$store.state.fixedDeparture.entity.totalDays;
      },
      set(val) {
        this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
          key: "totalDays",
          value: val
        });
      }
    },
    remarks: {
      get() {
        return this.$store.state.fixedDeparture.entity.remarks;
      },
      set(val) {
        this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
          key: "remarks",
          value: val
        });
      }
    },
    maxGroupSize: {
      get() {
        return this.$store.state.fixedDeparture.entity.maxGroupSize;
      },
      set(val) {
        this.$store.commit("fixedDeparture/SET_FIXED_DEPARTURE_DATA", {
          key: "maxGroupSize",
          value: val
        });
      }
    }
  },
  data() {
    return {
      pageTitle: "Add Fixed Departure",
      loading: false,
      menu: {
        departureDate: false
      },
      menu1: false,
      todayDate: commonservice.formatDate(new Date())
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.params.id) {
      store
        .dispatch("fixedDeparture/setFixedDeparture", { id: to.params.id })
        .then(() => {
          next(p => {
            p.pageTitle = "Edit Fixed Departure";
          });
        });
    } else {
      if (store.state.fixedDeparture.entity.contentId) {
        next(p => {
          p.reset();
        });
      } else {
        next("/content");
      }
    }
  },
  methods: {
    submit() {
      if (this.loading) return;
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;
          this.$store
            .dispatch("fixedDeparture/save")
            .then(
              () => {
                commonservice.showSuccessMessage(
                  "Fixed Departure saved successfully"
                );
                this.$router.push("/fixedDeparture");
                this.loading = false;
              },
              () => {
                this.loading = false;
              }
            )
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    reset() {
      this.$store.commit("fixedDeparture/RESET");
      setTimeout(() => {
        this.errors.clear();
      }, 10);
    }
  }
};
</script>
